export const HOME_URL_STORAGE_KEY = 'homeurl';
